module.exports = __webpack_public_path__ + "static/img/envelope02zh-tw.37646de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/envelope02zh-tw.png
// module id = 9CXl
// module chunks = 1